/* The Cove Charleston: shared Filter & Sort drawer behavior */
(() => {
  'use strict';

  const getDrawerDetails = (element) => element?.closest('.mobile-facets__wrapper')?.querySelector('details');

  const closeDrawer = (details) => {
    if (!details?.open) return;
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.click();
    else details.removeAttribute('open');
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-cove-facets-close]');
    if (closeButton) {
      event.preventDefault();
      closeDrawer(getDrawerDetails(closeButton));
      return;
    }

    const backdrop = event.target.closest('.facets-container-drawer .mobile-facets');
    if (!backdrop) return;
    if (event.target.closest('.mobile-facets__inner')) return;

    event.preventDefault();
    closeDrawer(getDrawerDetails(backdrop));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document
      .querySelectorAll('.facets-container-drawer .mobile-facets__disclosure[open]')
      .forEach(closeDrawer);
  });
})();
